







































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import GroupingPackage from '@/store/entities/grouping-packages/grouping-package';
import GroupingPackageDetail from '@/store/entities/grouping-packages/grouping-package-detail';
import _ from 'lodash';

class  PageUnitRequest extends PageRequest{
    keyword:string;
}
@Component({
    
})
export default class CreateGroupingPackage extends AbpBase{
    namespace = 'deliveryPackageGroup';
    pagerequest:PageUnitRequest=new PageUnitRequest();
    grouping : GroupingPackage = new GroupingPackage();
    isShowInfoGroup: boolean = false;
    packages : GroupingPackageDetail[] = new Array<GroupingPackageDetail>();

    get loading(){
        return this.$store.state.deliveryPackageGroup.loading;
    }

    async onScan(){
        let code = this.pagerequest.keyword.trim();
        await this.$store.dispatch({
            type: `${this.namespace}/getInfoPackageToGroup`,
            data: { code: code }
        }).then((res) => {
            this.onResetAndFocusInput();
            if(this.grouping.aoGroupCode === undefined){
                this.isShowInfoGroup = true;
                this.grouping = new GroupingPackage();
                this.grouping.aoGroupCode = res.aoGroupCode;
                this.grouping.customerName = res.customerName;
                this.grouping.customerPhone = res.customerPhone;
                this.grouping.shippingFullAddress = res.shippingFullAddress;
                this.grouping.sumPackage = res.sumPackage;
                this.grouping.tplCode = res.tplCode;
                this.grouping.tplName = res.tplName;

                this.packages = new Array<GroupingPackageDetail>();
                let infoPackage = new GroupingPackageDetail();
                infoPackage.packageId = res.packageId;
                infoPackage.soCode = res.soCode;
                infoPackage.packageCode = res.packageCode;
                infoPackage.externalCode = res.externalCode;
                this.packages.push(infoPackage);
                this.grouping.sumPackage = this.packages.length;
            }
            else{
                if(this.grouping.aoGroupCode !== res.aoGroupCode || this.grouping.tplCode !== res.tplCode){
                    let msg = Util.L("Error.PackageIsNotFromTheSameTplAsThePreviousPackage");
                    msg = msg.replace('#0', code);
                    Util.showNoticeErrorMsg(this, msg);
                    return;
                }

                if(_.some(this.packages, {'packageId': res.packageId})){
                    Util.showNoticeErrorMsg(this,Util.L("Error.PackageAddedIntoTheGroup"));
                    return;
                }

                let infoPackage = new GroupingPackageDetail();
                infoPackage.packageId = res.packageId;
                infoPackage.soCode = res.soCode;
                infoPackage.packageCode = res.packageCode;
                infoPackage.externalCode = res.externalCode;
                this.packages.push(infoPackage);
                this.grouping.sumPackage = this.packages.length;
            }
            
        }).catch(() =>{
            this.onResetAndFocusInput();
        });
    }

    onRemovePackage(packageId){
        this.$Modal.confirm({
            title:this.L('Confirm'),
            content:this.L('Comfirm.RemovePackageOutGroup'),
            okText:this.L('Yes'),
            cancelText:this.L('No'),
            onOk: () => {
                this.packages = _.filter(this.packages, (x) => { return x.packageId != packageId });
                this.grouping.sumPackage = this.packages.length;
                if(this.grouping.sumPackage === 0){
                    this.isShowInfoGroup = false;
                    this.grouping = new GroupingPackage();
                }
            }
        })
    }

    saveGroup(){
        this.$Modal.confirm({
            title:this.L('Confirm'),
            content:this.L('Comfirm.CreateGroup'),
            okText:this.L('Yes'),
            cancelText:this.L('No'),
            onOk: async () => {
                await this.onSaveGroup();
            }
        });
    }

    async onSaveGroup(){
        var param = {
            packageIds : _.map(this.packages, 'packageId')
        };
        await this.$store.dispatch({
            type: `${this.namespace}/createOrUpdateGroupingPackage`,
            data: param
        }).then((res) => {
            this.$root.$router.push({name: 'grouping-package/view/:code', params: {code: res}})
        }).catch(() => {
            this.onResetAndFocusInput();
        });
    }

    onResetAndFocusInput(){
        this.$set(this.pagerequest, 'keyword', '');
        (this.$refs.txtFirstInput as any).focus();
    }

    onBack(){
        this.$router.push({name: 'grouping-package'});
    }

    packageColumns = [
        {
            title:Util.L('Order'),
            align: "center",
            slot: "order",
        },{
            title:Util.L('Package'),
            key:'packageCode'
        },{
            title:Util.L('SoCode'),
            key:'soCode'
        },{
            title:Util.L('ExternalCode'),
            key:'externalCode'
        },{
            title:Util.L('Action'),
            align: "center",
            slot: "action",
        }
    ]

    created(){
        setTimeout(() => this.onResetAndFocusInput(), 500);
    }
}
